/**
 * footer-new-section — mobile dropdown toggle functionality
 */
(function () {
  'use strict';

  function initFooterDropdowns() {
    const toggles = document.querySelectorAll('.fns__dropdown-toggle');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !isExpanded);
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.fns__col--menu')) {
        toggles.forEach(function (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterDropdowns);
  } else {
    initFooterDropdowns();
  }
})();
